import * as React from "react";
const PaymentMethodUpdateIcon = (props: any) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.66683 6.1665H1.3335C1.06016 6.1665 0.833496 5.93984 0.833496 5.6665C0.833496 5.39317 1.06016 5.1665 1.3335 5.1665H7.66683C7.94016 5.1665 8.16683 5.39317 8.16683 5.6665C8.16683 5.93984 7.94016 6.1665 7.66683 6.1665Z"
      fill="#6D77A0"
    />
    <path
      d="M5.33333 11.5H4C3.72667 11.5 3.5 11.2733 3.5 11C3.5 10.7267 3.72667 10.5 4 10.5H5.33333C5.60667 10.5 5.83333 10.7267 5.83333 11C5.83333 11.2733 5.60667 11.5 5.33333 11.5Z"
      fill="#6D77A0"
    />
    <path
      d="M9.66667 11.5H7C6.72667 11.5 6.5 11.2733 6.5 11C6.5 10.7267 6.72667 10.5 7 10.5H9.66667C9.94 10.5 10.1667 10.7267 10.1667 11C10.1667 11.2733 9.94 11.5 9.66667 11.5Z"
      fill="#6D77A0"
    />
    <path
      d="M11.7068 14.1668H4.2935C1.64016 14.1668 0.833496 13.3668 0.833496 10.7402V5.26016C0.833496 2.6335 1.64016 1.8335 4.2935 1.8335H9.66683C9.94016 1.8335 10.1668 2.06016 10.1668 2.3335C10.1668 2.60683 9.94016 2.8335 9.66683 2.8335H4.2935C2.20016 2.8335 1.8335 3.1935 1.8335 5.26016V10.7335C1.8335 12.8002 2.20016 13.1602 4.2935 13.1602H11.7002C13.7935 13.1602 14.1602 12.8002 14.1602 10.7335V8.0135C14.1602 7.74016 14.3868 7.5135 14.6602 7.5135C14.9335 7.5135 15.1602 7.74016 15.1602 8.0135V10.7335C15.1668 13.3668 14.3602 14.1668 11.7068 14.1668Z"
      fill="#6D77A0"
    />
    <path
      d="M10.3468 7.6267C10.0868 7.6267 9.84011 7.53337 9.66678 7.35337C9.45345 7.14003 9.36011 6.83337 9.40678 6.51337L9.54011 5.5667C9.57345 5.3267 9.72011 5.04003 9.88678 4.87337L12.3601 2.40003C13.3401 1.42003 14.1934 1.98003 14.6201 2.40003C15.0401 2.82003 15.6001 3.67337 14.6201 4.66003L12.1468 7.13337C11.9734 7.3067 11.6868 7.4467 11.4534 7.48003L10.5068 7.61337C10.4534 7.62003 10.4001 7.6267 10.3468 7.6267ZM13.4868 2.85337C13.3534 2.85337 13.2334 2.9467 13.0668 3.1067L10.6001 5.58003C10.5801 5.6067 10.5401 5.68003 10.5334 5.71337L10.4001 6.61337L11.3068 6.4867C11.3401 6.48003 11.4134 6.44003 11.4401 6.42003L13.9134 3.9467C14.2268 3.63337 14.2734 3.46003 13.9134 3.1067C13.7401 2.93337 13.6134 2.85337 13.4868 2.85337Z"
      fill="#6D77A0"
    />
    <path
      d="M13.9131 5.16004C13.8665 5.16004 13.8198 5.15337 13.7798 5.14004C12.8665 4.88004 12.1398 4.16004 11.8865 3.2467C11.8131 2.98004 11.9665 2.7067 12.2331 2.6267C12.4998 2.55337 12.7731 2.7067 12.8531 2.97337C13.0198 3.55337 13.4798 4.01337 14.0598 4.18004C14.3265 4.25337 14.4798 4.53337 14.4065 4.79337C14.3331 5.01337 14.1331 5.16004 13.9131 5.16004Z"
      fill="#6D77A0"
    />
  </svg>
);
export default PaymentMethodUpdateIcon;
